import { render, staticRenderFns } from "./VatExplain.vue?vue&type=template&id=3584944f&"
import script from "./VatExplain.vue?vue&type=script&lang=js&"
export * from "./VatExplain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports